module.exports = __webpack_public_path__ + "static/img/attachment.ccfee77a.svg";